<template>
	<div>
		<p>
			<b-badge
				v-if="addressNotFound"
				style="font-size: 14px;"
				variant="danger"
				>No se econtr&oacute; la direcci&oacute;n {{ address }}
			</b-badge>
		</p>
		<l-map
			style="height: 600px"
			:zoom="zoom"
			:center="center"
			@click="addMarkerClick"
			:options="optionsForMap"
			ref="mapRef"
		>
			<l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
			<l-control-zoom
				position="bottomright"
				zoomInTitle="Acercar"
				zoomOutTitle="Alejar"
			></l-control-zoom>
			<l-marker
				:key="index"
				v-for="(m, index) in markers"
				:lat-lng="m.position"
				:draggable="true"
				@dragend="dragMarker"
				ref="markerRef"
			></l-marker>
		</l-map>
	</div>
</template>

<script>
	import { Icon } from 'leaflet';
	import { LMap, LTileLayer, LMarker, LControlZoom } from 'vue2-leaflet';
	import geocoderAddress from '../functions/functionGeoCodeAddres';
	delete Icon.Default.prototype._getIconUrl;
	Icon.Default.mergeOptions({
		iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
		iconUrl: require('leaflet/dist/images/marker-icon.png'),
		shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
	});

	export default {
		name: 'LeafletMap',
		components: {
			LMap,
			LTileLayer,
			LMarker,
			LControlZoom,
		},
		props: {
			latitude: {
				type: Number,
				default: function() {
					return 0;
				},
			},
			longitude: {
				type: Number,
				default: function() {
					return 0;
				},
			},
			zoom: {
				type: Number,
				default: function() {
					return 6;
				},
			},
			//prop para indicar si se debe mostrar el input autocomplete de google maps
			showInputAutocomplete: {
				type: Boolean,
				default: function() {
					return true;
				},
			},
			// prop para indicar si se debe centrar al relizar el geolocate del navegador, por defecto es true
			centerGeoLocate: {
				type: Boolean,
				default: function() {
					return true;
				},
			},
			//prop para inidcar si se debe crear el marcador en el mapa
			//en base a las cordenadas enviadas en el los props longitud y latitud
			createMarker: {
				type: Boolean,
				default: function() {
					return true;
				},
			},
			address: {
				type: String,
				default: function() {
					return '';
				},
			},
		},
		data() {
			return {
				addressNotFound: false,
				url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
				attribution:
					'&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
				// zoom: 6,
				center: [6.42375, -66.58973],
				markerLatLng: [6.42375, -66.58973],
				markers: [],
				optionsForMap: {
					scrollWheelZoom: false,
					zoomControl: false,
				},
				leafletMap: undefined,
			};
		},
		created() {
			if (this.createMarker) {
				const marker = {
					lat: this.$props.latitude,
					lng: this.$props.longitude,
				};
				this.markers.push({
					position: marker,
				});
			}
		},
		mounted() {
			if (this.address !== '') {
				this.geocodeAddres();
			} else {
				this.geolocate();
			}
			if (this.markers.length > 0) {
				this.$refs.mapRef.fitBounds([
					[
						this.markers[0].position.lat,
						this.markers[0].position.lng,
					],
				]);
			}
		},
		methods: {
			addMarkerClick(value) {
				let newMarker = {
					lat: value.latlng.lat,
					lng: value.latlng.lng,
				};
				this.markers = [];
				this.markers.push({
					position: newMarker,
					markerFrom: 'user',
				});
				this.$refs.mapRef.fitBounds([[newMarker.lat, newMarker.lng]]);
				this.addressNotFound = false;
				this.$emit('addMarker', this.markers);
			},
			geocodeAddres() {
				geocoderAddress
					.getGeoCodeAddress(this.address)
					.then((result) => {
						if (result !== undefined) {
							let newMarker = {
								lat: result.lat,
								lng: result.lng,
							};
							this.markers = [];
							this.markers.push({
								position: newMarker,
								markerFrom: 'google',
							});
							this.$refs.mapRef.fitBounds([
								[newMarker.lat, newMarker.lng],
							]);
						} else {
							this.addressNotFound = true;
							//this.geolocate();
						}
					})
					.catch((err) => {
						console.log(err);
					});
			},
			geolocate: function() {
				if (this.centerGeoLocate) {
					navigator.geolocation.getCurrentPosition((position) => {
						let marker = {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						};
						this.markers = [];
						this.markers.push({
							position: marker,
							markerFrom: 'google',
						});
						this.$refs.mapRef.fitBounds([[marker.lat, marker.lng]]);
					});
				} else {
					this.center = {
						lat: this.latitude,
						lng: this.longitude,
					};
				}
			},
			dragMarker(value) {
				let newMarker = {
					lat: value.target.getLatLng().lat,
					lng: value.target.getLatLng().lng,
				};
				this.markers = [];
				this.markers.push({
					position: newMarker,
					markerFrom: 'user',
				});
				this.$refs.mapRef.fitBounds([[newMarker.lat, newMarker.lng]]);
				this.$emit('dragMarker', this.markers);
			},
		},
	};
</script>
